<template>

    <h2>Persönliche Daten</h2>

    <form @submit.prevent="onSubmit" novalidate class="mb-8">
            <base-input v-model.trim="userData.surname"
                        :value="'ASD'"
                        :id-prefix="'surname'"
                        name="surname"
                        :validations="[{ condition: v$.userData.surname.required &&  v$.userData.surname.$error && userData.surname == '',text:'Bitte tragen Sie Ihren Vornamen ein!'}]"
                        ref="register-surname"
                        :type="'text'" label="default.surname" required/>

            <base-input v-model.trim="userData.name"
                        :id-prefix="'name'"
                        name="name"
                        :validations="[{ condition: v$.userData.name.required &&  v$.userData.name.$error && userData.name == '',text:'Bitte tragen Sie Ihren Nachnamen ein!'}]"
                        ref="register-name"
                        :type="'text'" label="default.lastname" required/>

            <base-input v-model.trim="userData.company"
                        :id-prefix="'company'"
                        name="company"
                        :validations="[{ condition: v$.userData.company.required &&  v$.userData.company.$error && userData.company == '',text:'Bitte tragen Sie Ihre Firma ein!'}]"
                        ref="register-company"
                        :type="'text'" label="default.company" required/>

        <div class="text-right">
            <base-button type="submit" class="inline-block" :loading="axiosCall">
                account speichern
            </base-button>
        </div>

    </form>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {required} from '@vuelidate/validators'
import {ref, computed, getCurrentInstance, watch, nextTick} from 'vue'
import {useStore} from "vuex";
import {API} from "@/utils/api";
import {useRouter} from "vue-router";

export default {
    setup(props) {

        console.log('props',props)

        const store = useStore();
        const router = useRouter();
        const userData = computed(() => store.getters['Customer/userData'])
        const axiosCall = ref(false);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const rules = computed(() => ({
            userData: {
                name: {required},
                surname: {required},
                company: {required},
            }
        }))

        const v$ = useVuelidate(rules, {userData})

        watch(userData, (selection, prevSelection) => {
           // name.value = userData.value.name;
          //  surname.value = userData.value.surname;
          //  company.value = userData.value.company;
        })

        const onSubmit = () => {

            v$.value.userData.$touch()

            if (v$.value.$error) return;

            axiosCall.value = true

            const accountData = {
                name: userData.value.name,
                surname: userData.value.surname,
                company: userData.value.company,
            }

            API.post('updateProfile', accountData).then((resp) => {
                axiosCall.value = false
                emitter.emit("flash-message", {
                    text: resp.data.message,
                    type: 'success'
                })

                store.dispatch('Customer/setUser', resp.data.user);

            }).catch(err => {
                axiosCall.value = false
                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })

        }

        (async ()  => {
            await nextTick();
            API.get('user').then((response) => {
                store.dispatch('Customer/setUser', response.data)

            }).catch((error) => {

                console.error(error)
                store.dispatch('Customer/logout');
                emitter.emit("flash-message", {
                    text: 'Fehler',
                    type: 'error'
                })
                router.push('/account');
            })
        })();

        return {

            userData,
            onSubmit,
            v$,
            axiosCall
        }
    }
}
</script>
